import type { Icon } from "./icon";

type GuideCardAction =
  | { type: "show-article"; articleId: number }
  | { type: "open-checklist"; checklistId: number }
  | { type: "replay-video" }
  | { type: "start-tour"; tourId: number };

export interface GuideCard {
  id: string;
  icon: Icon;
  title: string;
  description?: string;
  action: GuideCardAction;
}

export const INTERCOM_TOURS = {
  quick_start: 20565,
};

export const INTRO_VIDEO_URL =
  "https://static-piplanning.s3.amazonaws.com/website/onboarding/Intro%20Video%20Onboarding%20Flow.mp4";

export const featuredCard: GuideCard = {
  id: "get-ready",
  icon: "general/rte-cockpit",
  title: /*$t*/ "onboardingGuide.getReady.title",
  description: /*$t*/ "onboardingGuide.getReady.description",
  action: { type: "open-checklist", checklistId: 1232509 },
};

export const primaryCards: readonly GuideCard[] = [
  {
    id: "lead-planning",
    icon: "general/facilitation",
    title: /*$t*/ "onboardingGuide.leadPlanning.title",
    description: /*$t*/ "onboardingGuide.leadPlanning.description",
    action: { type: "show-article", articleId: 604747 },
  },
  {
    id: "plan-across",
    icon: "board/planning",
    title: /*$t*/ "onboardingGuide.planAcross.title",
    description: /*$t*/ "onboardingGuide.planAcross.description",
    action: { type: "show-article", articleId: 608933 },
  },
  {
    id: "dependencies",
    icon: "general/link",
    title: /*$t*/ "onboardingGuide.dependencies.title",
    description: /*$t*/ "onboardingGuide.dependencies.description",
    action: { type: "show-article", articleId: 609591 },
  },
];

export const secondaryActions: readonly GuideCard[] = [
  {
    id: "intro-video",
    icon: "general/play",
    title: /*$t*/ "onboardingGuide.introVideo.title",
    action: { type: "replay-video" },
  },
  {
    id: "take-a-tour",
    icon: "general/pointer",
    title: /*$t*/ "onboardingGuide.navigation.title",
    action: { type: "start-tour", tourId: INTERCOM_TOURS.quick_start },
  },
];
